import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SKILLS_URL } from '../utils/brand';

/**
 * 2days project 는 Koready Skills 로 옮겼다 — 옛 주소(/2days/…, 선발 메일 · 체크인 알림 · 공유 링크)를 같은 경로로 넘긴다.
 * 상세페이지는 Skills 에서 /2days-project.
 */
const TwoDaysMoved = () => {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/^\/2days\/project\/?$/, '/2days-project');
    window.location.replace(`${SKILLS_URL}${path}${search}${hash}`);
  }, [pathname, search, hash]);
  return null;
};

export default TwoDaysMoved;
